module.exports = Em.Component.extend({
    annualReport: Em.inject.service(),

    classNames: ['ar-input-field']
})
